<script setup lang="ts">
import RegisterForm from '#modules/auth/components/RegisterForm.vue';

definePageMeta({
  layout: 'auth',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});

useHead({
  title: 'Register',
});
</script>

<template>
  <RegisterForm />
</template>
